import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { Divider } from 'antd';
import styles from './InstructionContent.scss';

const InstructionContent = ({ content }) => {
  const [value, setValue] = React.useState('');

  React.useEffect(() => {
    setValue(content || '');
  }, [content]);
  const modules = {
    toolbar: false, // Disable toolbar for read-only mode
    clipboard: {
      matchVisual: false, // Prevent visual matching
    },
  };

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'color',
  ];

  return (
    <div style={{ width: '680px', height: 'auto', minHeight: '300px', margin: 'auto' }}>
      <ReactQuill
        theme="bubble"
        readOnly={true}
        value={value}
        modules={modules}
        formats={formats}
        className={styles['instruction-content']}
      />
    </div>
  );
};

export default InstructionContent;
